import React from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';

const InsightsHeader = (): JSX.Element => {
  return <PageHeader title="Insights" subtitle="Choose day in the date picker for getting insights for this day." />;
};

export default InsightsHeader;
